import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var _dec, _class;

import { injectable } from 'inversify';
import 'reflect-metadata';
/**
 * 更新图层样式，初始图层相关配置
 */

var LayerStylePlugin = (_dec = injectable(), _dec(_class = /*#__PURE__*/function () {
  function LayerStylePlugin() {
    _classCallCheck(this, LayerStylePlugin);
  }

  _createClass(LayerStylePlugin, [{
    key: "apply",
    value: function apply(layer) {
      layer.hooks.afterInit.tap('LayerStylePlugin', function () {
        var _layer$getLayerConfig = layer.getLayerConfig(),
            autoFit = _layer$getLayerConfig.autoFit,
            fitBoundsOptions = _layer$getLayerConfig.fitBoundsOptions;

        if (autoFit) {
          layer.fitBounds(fitBoundsOptions);
        }
      });
    }
  }]);

  return LayerStylePlugin;
}()) || _class);
export { LayerStylePlugin as default };